exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-table[data-v-ded0ac34] {\n  position: relative;\n}\n.dynamic-table .atable-filter[data-v-ded0ac34] {\n    margin-bottom: 10px;\n    padding-right: 10px;\n    text-align: right;\n}\n", ""]);

// exports
